/* OM floating navigation: mobile dock and desktop bar with its menu panel.
   Ported from tools/design-polish/site/om.js. Markup: snippets/om-mobile-topbar.liquid and
   snippets/om-mobile-bottom-nav.liquid; menu model: snippets/om-nav-data.liquid.
   Search and cart are the theme's own: [data-om-search-toggle] opens the search dialog
   (om-between-search.js) and [data-drawer-toggle="drawer-cart"] is bound by Pipeline's Drawer. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const dock = $('#om-dock'), top = $('#om-top'), scrimEl = $('#om-scrim'), source = $('#om-nav-data');
  if (!dock || !top || !scrimEl || !source) return;
  /* ---------- the place on the page while the theme locks it ----------
     Pipeline locks the page behind an open cart, and behind its other drawers, with a library
     that on an iPhone or iPad makes the body position:fixed and means to hold the page where it
     was with top: -scrollY. It writes that number without a unit, which no browser takes: the page
     showed its top behind the cart and was left there when the cart closed (Henric, 2026-10-12:
     "varukorgen som hoppar högst upp"). The value is written here with its unit, so the page stays
     where it was, and the library's own way back, which reads that value, returns to it. That
     return would glide, since the page scrolls smoothly by its stylesheet; it is made at once.
     pageY() is where the page is, held or not: scrollY says 0 for as long as the body is fixed. */
  let placeY = scrollY, held = false;
  const pageY = () => held ? placeY : scrollY;
  addEventListener('scroll', () => { if (!held && document.body.style.position !== 'fixed') placeY = scrollY; }, { passive: true });
  new MutationObserver(() => {
    const page = document.body, fixed = page.style.position === 'fixed';
    if (fixed && !held) { held = true; if (!page.style.top && placeY > 0) page.style.top = -placeY + 'px'; }
    else if (!fixed && held) { held = false; scrollTo({ top: placeY, left: 0, behavior: 'instant' }); last = placeY; }
  }).observe(document.body, { attributes: true, attributeFilter: ['style'] });
  // The desktop bar is a plain row only at the very top of a page (om-dock.css, data-flat).
  // On the homepage it stays that row, in the page's own flow, until the hero card covers the place
  // where the floating bar stands: one scrolls away from the row like from anything else, the bar
  // waits behind the hero and comes out under the hero's lower edge; on the way up the hero covers
  // it again and the row is back at the top (Henric, 2026-10-09). The switch is made where the
  // hero's straight edge hides it: its top has to be past its own corner radius.
  // Bound before the menu model is read: a row left without its surface over the page could not be read.
  const hero = $('.template-index .om-editorial-hero, .template-index .om-oma-hero');
  const flat = () => {
    let on = pageY() <= 10;
    if (hero && top.offsetParent) {   // the homepage, and the bar is shown (from 1000px)
      const box = hero.getBoundingClientRect();
      if (box.height) on = box.top > -(parseFloat(getComputedStyle(hero).borderTopLeftRadius) || 0) - 2;
    }
    top.dataset.flat = on ? 'on' : 'off';
  };
  addEventListener('scroll', flat, { passive: true }); addEventListener('resize', flat, { passive: true }); flat();
  let NAV;
  try { NAV = JSON.parse(source.textContent); } catch (e) { console.error('om-dock: the menu model in #om-nav-data is not valid JSON, the menu is off', e); return; }
  const root = document.documentElement, body = document.body;
  const mMenu = $('#om-dock-menu'), mPanel = $('#om-dock-panel'), mHost = $('#om-dock-view');
  const dMenu = $('#om-top-menu'), dPanel = $('#om-top-panel'), dHost = $('#om-top-view');
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- icons ---------- */
  const s = (d, cls = '') => `<svg ${cls ? `class="${cls}" ` : ''}viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
  const I = {
    user: s('<circle cx="12" cy="8.5" r="3.5"/><path d="M5 20c.8-3.6 3.5-5.5 7-5.5s6.2 1.9 7 5.5"/>'),
    arrow: s('<path d="M4 12h15M13 6l6 6-6 6"/>', 'omn-arrow'),
    chev: s('<path d="M9 5l7 7-7 7"/>'),
    back: s('<path d="M15 5l-7 7 7 7"/>')
  };

  /* ---------- menu views ---------- */
  // Menu URLs are merchant-entered. Anything but a relative, http(s), mailto or tel target is dropped.
  const href = u => /^(?:[/#?]|https?:|mailto:|tel:)/i.test(String(u || '').trim()) ? esc(String(u).trim()) : '#';
  const a = (l, inner = null) => `<a href="${href(l.url)}"${/^https?:/i.test(l.url) ? ' target="_blank" rel="noopener"' : ''}>${inner ?? esc(l.label)}</a>`;
  const groups = NAV.cats.filter(n => n.links && n.links.length);
  const byId = id => NAV.cats.find(n => n.id === id) || groups[0];
  // The picture card: the same look as the homepage collection cards (title bottom left, arrow bottom right).
  const mcard = n => n.img && n.url ? `<a class="omn-mcard" href="${href(n.url)}" aria-label="Shop all ${esc(n.cardLabel || n.label)}"><img loading="lazy" src="${esc(n.img)}" alt=""><span class="omn-mcard__lbl"><span>${esc(n.cardLabel || n.label)}</span>${I.arrow}</span></a>` : '';
  // The accessibility tools open from here and from the footer (sections/footer.liquid), not from a
  // floating button: accessiBe opens for any element that carries data-acsb-custom-trigger. Only
  // offered while its script is on the page.
  const a11y = () => $('script[src*="acsbapp.com"]') ? `<button type="button" data-acsb-custom-trigger="true">${root.lang === 'sv' ? 'Tillgänglighet' : 'Accessibility'}</button>` : '';
  // The old drawer menu still renders the address from the header section's own setting.
  const mail = $('#header-menu .om-mobile-menu__social a[href^="mailto:"]');
  const views = {
    root: () => `<div class="omn-vhead"><span class="omn-vhead__title">Menu</span>${NAV.account ? `<a class="omn-vhead__acct" href="${href(NAV.account.url)}">${I.user} ${esc(NAV.account.label)}</a>` : ''}</div>
      <ul class="omn-l1">${NAV.cats.map(n => `<li>${n.links && n.links.length ? `<button type="button" data-omn-view="cat:${esc(n.id)}">${esc(n.label)}${I.chev}</button>` : a(n)}</li>`).join('')}</ul>
      ${NAV.second.length ? `<div class="omn-vsec omn-vlinks">${NAV.second.map(l => a(l)).join('')}</div>` : ''}
      <div class="omn-vsec omn-vfine">${NAV.policy.map(l => a(l)).join('')}${NAV.instagram ? a({ url: NAV.instagram }, 'Instagram ↗') : ''}${mail ? `<a href="${href(mail.getAttribute('href'))}">Email ↗</a>` : ''}${a11y()}</div>`,
    cat: id => {
      const n = byId(id), card = mcard(n);
      return `<div class="omn-vhead"><button type="button" class="omn-vback" data-omn-view="root" data-dir="back" aria-label="Back to menu">${I.back}</button><span class="omn-vhead__title">${esc(n.label)}</span></div>
        <ul class="omn-l2">${n.links.map(l => `<li>${a(l)}</li>`).join('')}</ul>
        ${card ? `<div class="omn-vcard">${card}</div>` : ''}`;
    },
    // Add to cart with no size chosen (see "the size sheet" below): the page's own size buttons,
    // by their place in the page's row, under the words that ask for one.
    size: () => {
      const sizes = sizeAsk ? $$('button', sizeAsk.group) : [];
      return `<p class="omn-size__title" id="omn-size-title">${esc(sizeAsk ? sizeAsk.title : '')}</p>
        <div class="omn-size__row${sizes.some(b => b.textContent.trim().length > 4) ? ' omn-size__row--wide' : ''}" role="group" aria-labelledby="omn-size-title">${sizes.map((b, i) => `<button type="button" data-omn-size="${i}"${b.disabled ? ' disabled' : ''}>${esc(b.textContent.trim())}</button>`).join('')}</div>`;
    },
    // The tab row is the panel's own first row and lies over the bar, so there is one row, not two.
    // It is rendered once per opening and then stands still: switching category only moves the
    // underline and swaps the pane below (deskSelect).
    desk: () => `<div class="omn-dhead"><button type="button" class="om-top__menu" data-omn-dclose>Close</button>
          <div class="omn-dtabs" role="tablist" aria-label="Shop">${NAV.cats.map(x => x.links && x.links.length
            ? `<button type="button" class="omn-dtab" role="tab" aria-selected="false" data-omn-desk="${esc(x.id)}">${esc(x.label)}</button>`
            : `<a class="omn-dtab" href="${href(x.url)}">${esc(x.label)}</a>`).join('')}<span class="omn-dline" aria-hidden="true"></span></div></div>
        <div class="omn-dbody"><div class="omn-dswap"></div>
          ${NAV.second.length ? `<div class="omn-dfoot">${NAV.second.map(l => a(l)).join('')}</div>` : ''}</div>`,
    pane: id => {
      const n = byId(id);
      return `<div class="omn-dpane"><div class="omn-dpane__links">${n.links.map((l, i) => `<span style="--i:${i}">${a(l)}</span>`).join('')}</div>${mcard(n)}</div>`;
    }
  };
  // Desktop: select a category inside the open panel. The underline slides to the tab, the pane
  // is replaced and the panel's height follows it instead of snapping.
  function deskSelect(id, animate) {
    const n = byId(id), swap = $('.omn-dswap', dHost), line = $('.omn-dline', dHost);
    const tabs = $$('[data-omn-desk]', dHost), tab = tabs.find(t => t.dataset.omnDesk === n.id);
    dView = n.id;
    tabs.forEach(t => t.setAttribute('aria-selected', String(t === tab)));
    if (tab && line) {
      if (!animate) line.style.transition = 'none';
      line.style.width = Math.max(0, tab.offsetWidth - 26) + 'px'; line.style.transform = `translateX(${tab.offsetLeft + 13}px)`;
      if (!animate) requestAnimationFrame(() => { line.style.transition = ''; });
    }
    const from = swap.offsetHeight;
    swap.style.height = ''; swap.innerHTML = views.pane(n.id);
    const to = swap.offsetHeight;
    if (animate && from && from !== to) {
      swap.style.height = from + 'px'; void swap.offsetHeight; swap.style.height = to + 'px';
      const done = e => { if (e.target !== swap) return; swap.style.height = ''; swap.removeEventListener('transitionend', done); };
      swap.addEventListener('transitionend', done);
    }
  }
  function show(host, name, dir) {
    const [v, arg] = name.split(':');
    host.innerHTML = `<div class="omn-view"${dir ? ` data-dir="${dir}"` : ''}>${views[v](arg)}</div>`;
    host.scrollTop = 0;
    const first = $('[role=tab][aria-selected=true]', host) || $('.omn-vback', host) || $('a,button:not([disabled])', host);
    if (first) first.focus({ preventScroll: true });
  }

  /* ---------- backdrop ----------
     Absolutely positioned page content, sized to the visible area plus a margin that reaches
     under Safari's bars (see .om-scrim in om-dock.css for why it is not position:fixed). */
  function scrim(on) {
    const margin = 260;
    if (!on) return void delete scrimEl.dataset.on;
    const y = pageY(), bottom = Math.min(Math.max(root.scrollHeight, body.scrollHeight), y + innerHeight + margin);   // a held page: the document is only as high as the window then
    scrimEl.style.top = (y - margin) + 'px'; scrimEl.style.height = (bottom - y + margin) + 'px'; scrimEl.dataset.on = '';
  }
  const scrimFollow = () => { if (scrimEl.hasAttribute('data-on')) scrim(true); };

  /* ---------- controllers ---------- */
  let compact = false, mView = null, dView = null, cartOpen = false, sizeAsk = null, sizeWait = null;
  const isDesk = () => matchMedia('(min-width:1000px)').matches;
  const drawer = () => $('#drawer-cart');

  // The menu button is a symbol (three lines, an X while the menu or the cart is open: data-x,
  // om-dock.css); the word it used to show is its name. Markup without the symbol keeps the word.
  const mSym = $('svg', mMenu);
  function mLabel() {
    const open = dock.dataset.state === 'open', word = open || cartOpen ? 'Close' : 'Menu';
    if (mSym) { mMenu.setAttribute('aria-label', word); mMenu.toggleAttribute('data-x', open || cartOpen); }
    else mMenu.textContent = word;
    mMenu.setAttribute('aria-expanded', String(open));
  }
  function mOpen(name = 'root') {
    mView = name; dock.dataset.state = 'open'; dock.dataset.view = name.split(':')[0]; mPanel.inert = false;
    mPanel.setAttribute('aria-label', name === 'size' && sizeAsk ? sizeAsk.title : 'Menu');
    scrim(true); body.classList.add('om-nav-locked'); mLabel();
    show(mHost, name);
  }
  function mClose(refocus = true) {
    if (dock.dataset.state !== 'open') return;
    const left = mView;
    mView = null; dock.dataset.state = 'full'; mPanel.inert = true;
    scrim(false); body.classList.remove('om-nav-locked'); mLabel();
    if (refocus) mMenu.focus({ preventScroll: true });
    clearTimeout(sizeWait); sizeWait = null;
    // The size sheet closed without a size: the page is told, so a size chosen later only chooses.
    if (left === 'size' && sizeAsk) { sizeAsk = null; document.dispatchEvent(new CustomEvent('om:size-dismissed')); }
  }
  function dOpen(id, trigger) {
    if (!groups.length) return;
    dView = id; top.dataset.open = ''; top.dataset.compact = 'off'; dPanel.inert = false;
    scrim(true); body.classList.add('om-nav-locked');
    // the panel covers the bar's left side and logo: keep those out of the tab order meanwhile
    $$('.om-top__left,.om-top__logo', top).forEach(el => { el.inert = true; });
    $$('[aria-controls=om-top-panel]', top).forEach(b => b.setAttribute('aria-expanded', String(b === trigger)));
    dHost.innerHTML = views.desk(); dHost.scrollTop = 0;
    deskSelect(id, false);
    const first = $('[role=tab][aria-selected=true]', dHost) || $('a,button', dHost);
    if (first) first.focus({ preventScroll: true });
  }
  function dClose(refocus) {
    if (!dView) return;
    dView = null; delete top.dataset.open; top.dataset.compact = compact ? 'on' : 'off'; dPanel.inert = true;
    scrim(false); body.classList.remove('om-nav-locked');
    $$('.om-top__left,.om-top__logo', top).forEach(el => { el.inert = false; });
    const was = $('[aria-controls=om-top-panel][aria-expanded=true]', top);
    $$('[aria-controls=om-top-panel]', top).forEach(b => b.setAttribute('aria-expanded', 'false'));
    if (refocus && was) was.focus({ preventScroll: true });
  }

  function setCompact(on) {
    if (on === compact) return;
    compact = on;
    // Only the desktop bar folds. The phone's dock keeps its marks while one scrolls down
    // (Henric, 2026-10-12: "på mobil så skiter vi i shrink på meny när man scrollar nedåt").
    if (!dView) top.dataset.compact = on ? 'on' : 'off';
  }
  let last = scrollY;
  addEventListener('scroll', () => {
    scrimFollow();
    if (held) return;   // the page did not move: the theme holds it behind a drawer
    const y = scrollY, d = y - last;
    if (Math.abs(d) < 6) return;
    last = y;
    setCompact(y >= 90 && d > 0);
  }, { passive: true });

  // Capture phase: the search dialog's own listener stops propagation, and Pipeline binds the
  // cart toggles directly. An open menu has to close before either of them takes over.
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-om-search-toggle],[data-drawer-toggle="drawer-cart"]');
    if (t && (dock.contains(t) || top.contains(t))) { mClose(false); dClose(false); }
  }, true);
  document.addEventListener('click', e => {
    const t = e.target.closest('a,button');
    if (!t || !(dock.contains(t) || top.contains(t))) return;
    if (t === mMenu) {
      if (cartOpen && drawer()) return void drawer().dispatchEvent(new CustomEvent('theme:drawer:close'));
      return dock.dataset.state === 'open' ? mClose() : mOpen();
    }
    if (t.dataset.omnView) return show(mHost, mView = t.dataset.omnView, t.dataset.dir);
    if (t.dataset.omnSize && sizeAsk) {
      // A size in the size sheet: chosen on the page, which then adds it to the cart. The sheet
      // stays, the size marked, until the cart opens in its place (syncCart): one open dock, not a
      // dock that closes and opens again. If no cart comes, it closes; the page says what went wrong.
      const chosen = $$('button', sizeAsk.group)[t.dataset.omnSize];
      sizeAsk = null; t.setAttribute('aria-pressed', 'true'); t.parentElement.inert = true;
      sizeWait = setTimeout(() => mClose(false), 2500);
      return chosen && chosen.click();
    }
    if (t.hasAttribute('data-acsb-custom-trigger')) return mClose(false);   // the tools open over the page, not over the menu
    if (t === dMenu) return dOpen(dView || groups[0].id, t);
    if (t.dataset.omCat) return dOpen(t.dataset.omCat, t);
    if (t.dataset.omnDesk) return t.dataset.omnDesk === dView ? undefined : deskSelect(t.dataset.omnDesk, true);
    if (t.hasAttribute('data-omn-dclose')) return dClose(true);
    // A link inside the menu: close before it navigates. A same-page #anchor does not navigate at
    // all, and a page restored from the back/forward cache comes back exactly as it was left.
    if (t.matches('a[href]') && (mHost.contains(t) || dHost.contains(t))) { mClose(false); dClose(false); }
  });
  scrimEl.addEventListener('click', () => { mClose(false); dClose(false); if (cartOpen && drawer()) drawer().dispatchEvent(new CustomEvent('theme:drawer:close')); });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { mClose(); dClose(true); }
    if (e.key !== 'Tab') return;
    const scope = mView ? dock : dView ? top : null;   // keep focus inside the open menu
    if (!scope) return;
    const f = $$('a[href],button:not([disabled])', scope).filter(el => el.offsetParent && !el.closest('[inert]'));
    const first = f[0], lastEl = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
    else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
  });
  addEventListener('resize', () => { if (isDesk()) mClose(false); else dClose(false); syncCart(); scrimFollow(); });

  /* ---------- cart ---------- */
  const setCount = n => $$('[data-om-cart-n]').forEach(el => { el.textContent = n; el.dataset.n = n; });
  document.addEventListener('theme:cart:change', e => { if (e.detail && e.detail.cart) setCount(e.detail.cart.item_count); });
  addEventListener('pageshow', e => {   // restored from the back/forward cache: old count, maybe an open menu
    if (!e.persisted) return;
    mClose(false); dClose(false);
    fetch(NAV.cart + '.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(c => { setCount(c.item_count); shipTotal = c.total_price; shipDraw(); }).catch(() => {});
  });
  // Pipeline's aria-expanded on the toggles is unreliable; the drawer's class is the state.
  // On a phone the cart is the dock opened, as the menu is: the dock takes the open shape
  // (.om-dock--cart, om-dock.css) and the menu's backdrop lies behind the cart.
  const sheet = matchMedia('(max-width:767px)');
  function syncCart() {
    const was = dock.classList.contains('om-dock--cart');
    cartOpen = !!drawer() && drawer().classList.contains('drawer--visible');
    const on = cartOpen && sheet.matches;
    dock.classList.toggle('om-dock--cart', on);
    // The size sheet was waiting for the cart it filled: it gives way to it, the backdrop stays.
    // (However the cart came to open: the two are never open together.)
    if (cartOpen && mView === 'size') { mClose(false); scrim(on); }
    else if (on !== was && !mView && !dView) scrim(on);
    mLabel();
  }
  if (drawer()) { new MutationObserver(syncCart).observe(drawer(), { attributes: true, attributeFilter: ['class'] }); syncCart(); }
  /* The cart's total. Liquid writes it as the shop formats money with its currency ("399 SEK").
     After every change of the cart Pipeline's script writes it again as the money format plus
     the currency's code, whatever the format: the checkout button then read "399 SEK SEK"
     (Henric, 2026-10-12). Where the code stands twice at the end, one is taken off. Watched in
     the cart drawer and on the cart page, the two places that total is written. */
  const code = window.theme && theme.currencyCode;
  if (code) {
    const once = () => $$('[data-cart-final]').forEach(el => {
      const text = el.textContent.trim();
      if (text.endsWith(code + ' ' + code)) el.textContent = text.slice(0, -code.length - 1);
    });
    [drawer(), $('[data-section-type="cart"]')].filter(Boolean).forEach(place => new MutationObserver(once).observe(place, { childList: true, characterData: true, subtree: true }));
    once();
  }
  /* The cart's free shipping bar (snippets/om-shipping-note.liquid; Henric, 2026-10-12: "som en
     stapel … när man ökar på den så animeras den upp … som en morot"). The server writes the
     words and the bar once, with the page, and Pipeline's script redraws only the cart's lines
     and total: after every change of the cart they are set here, from the figures the snippet
     carries. The bar glides by its own transition (om-dock.css). In the drawer it is only moved
     while the drawer is open: a change made with the drawer closed (Add to cart) is drawn a
     moment after it has opened, so the bar is seen gliding from where it stood. */
  let shipTotal = null;
  const shipDraw = () => {
    if (shipTotal === null) return;
    $$('[data-om-ship]').forEach(el => {
      const goal = Number(el.dataset.goal), words = $('[data-om-ship-words]', el), fill = $('[data-om-ship-fill]', el);
      if (!(goal > 0) || !words || !fill) return;
      const inDrawer = el.closest('#drawer-cart');
      if (inDrawer && !inDrawer.classList.contains('drawer--visible')) return;
      const left = Math.max(0, goal - shipTotal);
      const amount = String(Math.ceil(left / 100)).replace(/\B(?=(\d{3})+$)/g, el.dataset.separator || '');
      const text = left ? el.dataset.wordsLeft.replace('||amount||', amount) : el.dataset.wordsThere;
      if (words.textContent !== text) words.textContent = text;
      el.classList.toggle('om-ship--there', !left);
      fill.style.setProperty('--om-ship', shipTotal > 0 ? Math.max(.04, Math.min(1, shipTotal / goal)) : 0);
    });
  };
  document.addEventListener('theme:cart:change', e => {
    const cart = e.detail && e.detail.cart;
    if (cart && typeof cart.total_price === 'number') { shipTotal = cart.total_price; shipDraw(); }
  });
  if (drawer()) new MutationObserver(() => { if (drawer().classList.contains('drawer--visible')) setTimeout(shipDraw, 360); }).observe(drawer(), { attributes: true, attributeFilter: ['class'] });

  /* ---------- product pages: the dock's buy button ----------
     It stands in for the page's own button: the product section's, or Pipeline's on the poster,
     mug, sticker and gift card pages. Same words, same state, and a tap on it is a tap on that
     button, so the variant logic keeps exactly one owner. Under the words: what is about to be
     added, the chosen size where the page has size buttons, else the price Pipeline's button shows. */
  const buy = $('#om-dock-buy');
  if (buy) {
    const real = $('.om-pdp .om-buy') || $('[data-add-to-cart]');
    if (!real) dock.classList.remove('om-dock--buy');   // no buy button on this page: the ordinary dock
    else {
      const words = $('[data-om-dock-buy-label]', buy), note = $('[data-om-dock-buy-note]', buy), scope = real.closest('form') || real;
      const sync = () => {
        const text = ($('[data-add-to-cart-text]', real) || real).textContent.trim();
        // Swedish only: "Lägg till i varukorg" is cut off in the dock at 375 px, so the dock says it
        // shorter (Henric, 2026-10-12). Any other wording of the real button (sold out, …) is kept.
        words.textContent = root.lang === 'sv' && window.theme && theme.strings && text === theme.strings.addToCart ? 'Lägg i korgen' : text;
        buy.disabled = real.disabled;
        const chosen = $$('.om-pdp__chips button[aria-pressed=true]', scope).map(b => b.textContent.trim()), price = $('[data-button-price]', real);
        note.textContent = chosen.length ? chosen.join(' / ') : price ? price.textContent.trim() : '';
      };
      buy.addEventListener('click', () => real.click());
      new MutationObserver(sync).observe(scope, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-pressed'] });
      sync();
    }
  }

  /* ---------- product pages: the size sheet ----------
     On a phone no size is chosen for the visitor (om-between-product.js). Add to cart without one,
     from the dock or from the page's own button, and the page asks: om:size-needed, with its own
     group of size buttons and the words to show. Where the dock is on screen it answers by opening
     with those sizes (views.size); a tap there is a tap on the page's button, and the page, which
     is waiting for exactly that, adds the size to the cart. Unanswered (from 1000px) the page
     points at its own buttons instead. */
  document.addEventListener('om:size-needed', e => {
    if (isDesk() || !e.detail || !e.detail.group) return;
    e.preventDefault();
    if (cartOpen && drawer()) drawer().dispatchEvent(new CustomEvent('theme:drawer:close'));
    sizeAsk = { group: e.detail.group, title: e.detail.title || '' };
    mOpen('size');
  });

  /* ---------- "New" links: /?nd=<category> selects that tab in the homepage New Drop ---------- */
  const nd = new URLSearchParams(location.search).get('nd');
  if (nd) document.addEventListener('DOMContentLoaded', () => {
    const drop = $('[data-new-drop]');
    if (!drop) return;
    const tab = $$('[role=tab]', drop).find(t => t.textContent.trim().toLowerCase() === nd.toLowerCase());
    if (tab) tab.click();
    drop.style.scrollMarginTop = '96px';
    drop.scrollIntoView({ block: 'start' });
  });
})();
